import { serializeObject } from "../common/helper";
import { Request } from "./HttpService";
import  FileService from "./FileService";

export const FileContentService = {
  search(pageSize, pageNumber, searchObject) {
    let serializsed = serializeObject(searchObject);
    return Request(
      `vitae/searchDocuments/${pageSize}/${pageNumber}?${serializsed}`
    );
  },

  exportToexcel(pageSize, pageNumber, filename, format, searchObject) {
    let url = `vitae/SearchDocuments/${pageSize}/${pageNumber}/${format}/export?${serializeObject(
      searchObject
    )}`;
    FileService.Download(url, filename);
  },
};
